import { FaUserCircle } from "react-icons/fa";
import "../../styles/common/header.css";

const Avatar = ({ avatar, firstName, lastName, size = "2rem" }) => {
  if (avatar?.url) {
    return (
      <img
        src={avatar.url}
        alt="User avatar"
        style={{ width: size, height: size }}
        className="avatar-img"
      />
    );
  }
  const initials = `${firstName?.[0] || ""}${
    lastName?.[0] || ""
  }`.toUpperCase();

  return (
    <div className="avatar-img-fallback" style={{ width: size, height: size }}>
      {initials}
    </div>
  );
  // return <FaUserCircle size={size} className="avatar-icon" />;
};

export default Avatar;
